import React from "react";
import { cn } from "./cn";

type Variant = "secondary" | "ghost";
type Size = "sm" | "md";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  "aria-label": string;
};

const base =
  "inline-flex items-center justify-center rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-brand/20 disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  secondary:
    "bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 hover:text-gray-900",
  ghost: "bg-transparent text-gray-500 hover:bg-gray-100 hover:text-gray-900",
};

const sizes: Record<Size, string> = {
  sm: "h-8 w-8",
  md: "h-9 w-9",
};

const IconButton: React.FC<Props> = ({
  variant = "secondary",
  size = "md",
  className,
  type = "button",
  ...rest
}) => (
  <button
    type={type}
    className={cn(base, variants[variant], sizes[size], className)}
    {...rest}
  />
);

export default IconButton;
